module.exports = __webpack_public_path__ + "img/img-flow-4.fc11ce42.png";